import { render, staticRenderFns } from "./VatReports.vue?vue&type=template&id=072134b9&"
import script from "./VatReports.vue?vue&type=script&lang=js&"
export * from "./VatReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072134b9')) {
      api.createRecord('072134b9', component.options)
    } else {
      api.reload('072134b9', component.options)
    }
    module.hot.accept("./VatReports.vue?vue&type=template&id=072134b9&", function () {
      api.rerender('072134b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/VatReports.vue"
export default component.exports